var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  button:focus {\n    outline: none;\n  }\n"], ["\n  display: flex;\n\n  button:focus {\n    outline: none;\n  }\n"])));
var ButtonGroup = (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isButtonActive = function (index, list) {
            return list.includes(index);
        };
        return _this;
    }
    ButtonGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, onButtonClick = _a.onButtonClick, appearance = _a.appearance, dimension = _a.dimension, children = _a.children, activeList = _a.activeList, restProps = __rest(_a, ["onButtonClick", "appearance", "dimension", "children", "activeList"]);
        return (React.createElement(Container, __assign({}, restProps), React.Children.map(children, function (child, index) {
            if (React.isValidElement(child)) {
                var active = _this.isButtonActive(index, activeList);
                return React.cloneElement(child, {
                    appearance: active ? appearance || 'primary' : 'secondary',
                    dimension: dimension,
                    onClick: function (event) {
                        if (typeof onButtonClick === 'function') {
                            onButtonClick(event, index);
                        }
                    },
                });
            }
            return null;
        })));
    };
    return ButtonGroup;
}(React.PureComponent));
export default ButtonGroup;
var templateObject_1;
//# sourceMappingURL=buttonGroup.js.map